import * as React from "react";
import styles from "./RespondingBackdrop.module.css";

/** Animated "rain" glow shown behind the composer while the agent is generating a
 *  response. Purely decorative; fades out ~40px above the input. */
export const RespondingBackdrop: React.FC = () => (
	<div className={styles.backdrop} aria-hidden>
		<div className={styles.rain} />
	</div>
);
